import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchTaskGroupsApi } from 'api/task_group'
import { TaskGroup, TaskGroupSearchForm } from 'entities/task_group'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { taskGroupColumnInfoList, TaskGroupTableData } from './task_group_table'
import { DisplaySetting, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'

type Props = {
    history: H.History
}

const TaskGroupsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<TaskGroupSearchForm>()
    const searchForm = useForm<TaskGroupSearchForm>({
        ...query,
        ordering: '-task_group_created_at',
        userGroupId: globalState.user.userGroups?.map((ug) => ug.id).join(','),
    })
    const api = useFetchTaskGroupsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<TaskGroup>()
    const taskGroupDisplaySetting = useDisplaySetting(taskGroupColumnInfoList(searchForm), 'TaskGroup')
    const displaySettings: DisplaySetting[] = [taskGroupDisplaySetting]

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof TaskGroupSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`task_groups?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            {/* <EditTaskGroupForm
                taskGroup={selectedTaskGroup}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            /> */}
            <ContentHeader
                headerTitle="タスクグループ"
                left={
                    <>
                        <SearchConditionView
                            searchForm={searchForm}
                            onClickRemoveButton={handleClickRemoveFilter}
                            hiddenSearchParams={['kind', 'userGroupId']}
                        />
                    </>
                }
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <TableRow>
                                {/* <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit> */}
                                <TableHeads displaySetting={taskGroupDisplaySetting} />
                                {query.kind === 'MATERIAL' && <TableCell th width={150}></TableCell>}
                                {/* </CheckboxTableRow> */}
                            </TableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={taskGroupDisplaySetting.getColumnLength() + 1}>
                            {api.response.results.map((taskGroup: TaskGroup) => {
                                return (
                                    <TableRow key={`taskGroup-${taskGroup.id}`}>
                                        {/* <CheckboxTableRow key={`taskGroup-${taskGroup.id}`} item={taskGroup} multipleCheckForm={multipleCheckForm}> */}
                                        <TaskGroupTableData taskGroup={taskGroup} displaySetting={taskGroupDisplaySetting} />
                                        {query.kind === 'MATERIAL' && (
                                            <TableCell align="center">
                                                <Button
                                                    size="sm"
                                                    onClick={() => {
                                                        props.history.push(`/tasks/materials?kind=MATERIAL&taskGroupId=${taskGroup.id}`)
                                                    }}
                                                >
                                                    資材タスク確認
                                                </Button>
                                            </TableCell>
                                        )}
                                        {/* </CheckboxTableRow> */}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="TaskGroup"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(TaskGroupsPage)
